import { render, staticRenderFns } from "./InventoryDrawer.vue?vue&type=template&id=156e3dc7"
import script from "./InventoryDrawer.vue?vue&type=script&lang=js"
export * from "./InventoryDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports